import React from 'react';
import { Styled } from './';

const Stepper = ({
  steps,
  width = '40%',
}: {
  steps: {
    number: number;
    label: string;
    isActive: boolean;
    isCompleted: boolean;
  }[];
  width?: string;
}) => {
  return (
    <Styled.StepperContainer>
      <Styled.StepsContainer $width={width}>
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <Styled.StepWrapper>
              <Styled.Step isActive={step.isActive || step.isCompleted}>
                {step.number}
              </Styled.Step>
              <Styled.StepLabel>{step.label}</Styled.StepLabel>
            </Styled.StepWrapper>
            {steps.length === index + 1 ? null : (
              <Styled.StepSeparator
                isActive={step.isActive || step.isCompleted}
              />
            )}
          </React.Fragment>
        ))}
      </Styled.StepsContainer>
    </Styled.StepperContainer>
  );
};

export default Stepper;
